// extracted by mini-css-extract-plugin
module.exports = {"offer":"EarnCreditsOffer_offer__5pn8Y","stacked":"EarnCreditsOffer_stacked__KotI7"};